import { Helmet } from "react-helmet-async"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../../Auth"
import { TransportPreferencesList } from "../../../../SupplierPaymentPreferences"

export default function TransportPaymentPreferencesPage() {
	return (
		<>
			<Helmet>
				<title>Transport Payment Preferences</title>
			</Helmet>
			<ForbidUnlessAuthorized
				permission={PERMISSIONS.VIEW_TRANSPORT_SERVICE_PROVIDERS}
			>
				<TransportPreferencesList />
			</ForbidUnlessAuthorized>
		</>
	)
}
